<template>
  <div>
    <h1 class="text-pagename">Set store type on app</h1>
    <v-layout row>
      <!-- <v-flex xs4></v-flex>
      <v-flex xs4>
        <v-spacer></v-spacer>
      </v-flex>-->
      <v-flex xs12>
        <v-toolbar dense flat>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search"
            single-line
            hide-details
            style="padding:0;"
          ></v-text-field>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-data-table
      :search="search"
      :headers="headers"
      :loading="loading_message"
      :items="types.store_types"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ countIndex(props.item) }}</td>
        <td style="padding:6px 0 0 0;">
          <img :src="props.item.store_type_image" width="50px" height="50px">
        </td>
        <td class="text-xs-center">{{ props.item.store_type_name_th }}</td>
        <td class="text-xs-center">{{ typeService(props.item) }}</td>
        <td class="text-xs-center" style="position:relative;">
          <v-switch
            v-model="props.item.store_type_popular"
            @change="popularType(props.item.store_type_popular)"
            v-if="bbbb == false"
            color="primary"
            class="popular_toggle"
          ></v-switch>
          <v-switch
            :disabled="props.item.store_type_popular == true ? false : true"
            v-model="props.item.store_type_popular"
            @change="popularType(props.item.store_type_popular)"
            v-if="bbbb == true"
            color="primary"
            class="popular_toggle"
          ></v-switch>
        </td>
      </template>

      <template slot="no-data">
        <div v-if="loading_message == false">No data available</div>
        <div v-else>
          <v-progress-circular :size="30" color="primary" indeterminate></v-progress-circular>Loading data ...
        </div>
      </template>
    </v-data-table>

    <!-- <div class="text-xs-center py-2">
      <v-pagination circle v-model="pagination.page" :length="pages"></v-pagination>
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    search: "",
    loading_message: false,
    aaaa: [],
    bbbb: false,
    pagination: { rowsPerPage: 10 },
    store_type_img: [],
    selectedItem: {
      store_type_name_th: null,
      store_type_service_id: null
    },
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
        value: "id"
      },
      {
        text: "Store Type Icon",
        align: "center",
        sortable: false,
        value: "store_type_img"
      },
      {
        text: "Store type name",
        align: "center",
        sortable: false,
        value: "store_type_name_th"
      },
      {
        text: "Store service name",
        align: "center",
        value: "store_service_name_temp",
        sortable: false
      },
      {
        text: "Popular",
        align: "center",
        value: "popular",
        sortable: false
      }
    ]
  }),
  computed: {
    ...mapState({
      types: state => state.fetchStoreBack.store_type,
      load_edit_index: state => state.fetchStoreBack.load_edit_index
    }),
    pages() {
      if (this.types.length != 0) {
        this.pagination.totalItems = this.types.store_types.length;
      }
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    aaaa: {
      handler: function() {
        let count = 0;
        for (let val of this.aaaa) {
          if (val == true) {
            count++;
          }
        }
        if (count >= 4) {
          this.bbbb = true;
        } else {
          this.bbbb = false;
        }
      },
      deep: true
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    countIndex(item) {
      return this.types.store_types.indexOf(item) + 1;
    },
    popularType(item) {},
    async initialize() {
      this.loading_message = true;
      await this.$store.dispatch("fetchStoreBack/getDataType");
      this.loading_message = false;
    },
    typeService(item) {
      for (let key in this.types.store_services) {
        if (
          this.types.store_services[key].store_service_id ==
          item.store_type_service_id
        ) {
          item.store_service_name_temp = this.types.store_services[
            key
          ].store_service_name_th;
          return item.store_service_name_temp;
          break;
        }
      }
    }
  }
};
</script>

<style scoped>
.popular_toggle {
  position: absolute;
  top: 13px;
  left: 40%;
}
</style>

